import * as actionTypes from './actionTypes';

export const toggleAddRule=()=>({
    type:actionTypes.TOGGLE_ADD_RULE
})